import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';

export interface ISignalPreferences {
  numberOfEmailOpens: number;
  isEmailOpenEnabled: boolean;
  numberOfLinkClicks: number;
  isLinkClickEnabled: boolean;
  isCompanyChangeEnabled: boolean;
  isRoleChangeEnabled: boolean;
  isWebsiteVisitEnabled: boolean;
  websiteVisitMinDuration: number;
  websiteVisitLocations: string[] | null;
  websiteVisitCompanySizes?: string[] | null;
  websiteVisitExcludedCompanySizes?: string[] | null;
  websiteVisitCompanyCountryCodes?: string[] | null;
  websiteVisitExcludedCompanyCountryCodes?: string[] | null;
  websiteVisitCompanyIndustries?: string[] | null;
  websiteVisitExcludedCompanyIndustries?: string[] | null;
  hasSnitcher: boolean;
  isRadarActive?: boolean | null;
  hideCompleted: boolean;
  isHiringEnabled: boolean;
  hiringFilterRoles: string[] | null;
  hiringFilterLocations: string[] | null;
  hiringFilterIndustries: string[] | null;
}

export default function useGetSignalPreferences() {
  const request: Request = {
    url: ENDPOINTS.signal.preferences.main,
    config: {
      method: 'get',
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.signal.preferences.main],
    queryFn: () => client(request),
  };

  const { data, ...rest } = useQuery<Response<ISignalPreferences>, CronoError>(
    requestConfig,
  );

  return { data, ...rest };
}
